/** 编辑器共用的读写文件小工具：把文本存成本地文件、或让用户挑一个文本文件 */

export function downloadText(filename, text, type = 'application/json;charset=utf-8') {
  try {
    const blob = new Blob([text], { type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 0);
    return true;
  } catch { return false; }
}

/** 弹出文件选择框，读成文本回调 */
export function pickText(accept, cb) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = accept;
  input.onchange = () => {
    const file = input.files && input.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => cb(String(reader.result || ''), file.name);
    reader.readAsText(file);
  };
  input.click();
}
